// src/components/charts/RetrasosImpagosCharts.jsx
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import DonutChart from '../agComponents/DonutChart';
import { PrincipalesAcreedoresChart } from './DeudaActivosCharts';
import BarrasHorizontalesChart from './BarrasHorizontalesChart';
import kpiService from '../../services/kpiService';

/**
 * Componente que agrupa los gráficos de Retrasos e Impagos (Imagen 3)
 * - Retrasos e impagos por área (barras horizontales - izquierda)
 * - Retrasos e impagos por área (dona - centro)
 * - Principales Acreedores (barras horizontales - derecha)
 */
const RetrasosImpagosCharts = ({ fechaInicio, fechaFin, empresaId }) => {
  const [retrasosData, setRetrasosData] = React.useState(null);
  const [retrasosDonutData, setRetrasosDonutData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await kpiService.getRetrasosImpagos({
          fechaInicio,
          fechaFin,
          empresaId,
        });

        if (response.success && response.data) {
          setRetrasosDonutData(response.data);
          
          // Transformar datos para barras horizontales - con validación
          if (response.data.data && Array.isArray(response.data.data)) {
            const barrasData = response.data.data.map(item => ({
              area: item.label || 'Sin nombre',
              porcentaje: Math.round(item.value || 0),
              color: item.color || '#3b82f6',
            }));
            setRetrasosData(barrasData);
          }
        }
      } catch (err) {
        console.error('Error fetching retrasos e impagos:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fechaInicio, fechaFin, empresaId]);

  if (loading) {
    return (
      <Row className="g-3 mb-4">
        <Col xs={12} className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
          <p className="mt-3 text-muted">Cargando datos...</p>
        </Col>
      </Row>
    );
  }

  return (
    <Row className="g-3 mb-4">
      {/* Retrasos e impagos por área - Barras */}
      <Col lg={4}>
        {retrasosData && retrasosData.length > 0 ? (
          <BarrasHorizontalesChart
            title="Retrasos e impagos por área"
            data={retrasosData}
            showPercentageLabel={true}
          />
        ) : (
          <div className="card h-100">
            <div className="card-body">
              <h5 className="mb-4">Retrasos e impagos por área</h5>
              <p className="text-muted text-center py-4">No hay datos disponibles</p>
            </div>
          </div>
        )}
      </Col>

      {/* Retrasos e impagos por área - Dona */}
      <Col lg={4}>
        {retrasosDonutData && retrasosDonutData.data && Array.isArray(retrasosDonutData.data) && retrasosDonutData.data.length > 0 ? (
          <div className="card h-100">
            <div className="card-body">
              <h5 className="mb-4">Retrasos e impagos por área</h5>
              <div className="text-center mb-3">
                <small className="text-muted">Áreas</small>
              </div>
              <DonutChart
                data={retrasosDonutData.data}
                angleKey="value"
                labelKey="label"
                height={300}
                innerRadiusRatio={0.65}
              />
              {/* Leyenda con porcentajes */}
              <div className="mt-3">
                {retrasosDonutData.data.map((item, idx) => (
                  <div key={idx} className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        style={{
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          backgroundColor: item.color || '#3b82f6',
                        }}
                      />
                      <small>{item.label || 'Sin nombre'}</small>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span className="badge" style={{ backgroundColor: '#10b981' }}>
                        + {item.value || 0}%
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="card h-100">
            <div className="card-body">
              <h5 className="mb-4">Retrasos e impagos por área</h5>
              <p className="text-muted text-center py-4">No hay datos disponibles</p>
            </div>
          </div>
        )}
      </Col>

      {/* Principales Acreedores */}
      <Col lg={4}>
        <PrincipalesAcreedoresChart
          fechaInicio={fechaInicio}
          fechaFin={fechaFin}
          empresaId={empresaId}
        />
      </Col>
    </Row>
  );
};

export default RetrasosImpagosCharts;